/**
 * MOCK — the signup use-case read-back endpoint does not exist yet.
 *
 * TODO(SELF-89): the backend is shipping an endpoint that exposes the role /
 * use-cases / channels a user picked during signup. Swap the body of
 * `useSignupUseCases` for that read (loading state included), confirm the
 * wire value for the automated-workflows use case, and delete the hardcoded
 * list. Until then every account passes the workflows gate, which is why
 * `essentials_onboarding` must stay off in production (SELF-138 is
 * blocked-for-production by SELF-89).
 */
export const SignupUseCase = {
  AutomatedWorkflows: 'automated_workflows',
} as const;
export type SignupUseCase = (typeof SignupUseCase)[keyof typeof SignupUseCase];

export type SignupUseCasesResult = {
  useCases: readonly SignupUseCase[];
  isLoading: boolean;
  /** Marks this as the SELF-89 placeholder so callers/tests can't mistake it for real data. */
  isMocked: true;
};

const MOCKED_SIGNUP_USE_CASES: SignupUseCasesResult = {
  useCases: [SignupUseCase.AutomatedWorkflows],
  isLoading: false,
  isMocked: true,
};

/** MOCK: always reports automated workflows among the signup use cases. See the TODO(SELF-89) above. */
export function useSignupUseCases(): SignupUseCasesResult {
  return MOCKED_SIGNUP_USE_CASES;
}

/**
 * The essentials onboarding cohort is anyone who picked automated workflows
 * during signup — the signup role deliberately does not matter.
 */
export function hasAutomatedWorkflowsUseCase(useCases: readonly SignupUseCase[]): boolean {
  return useCases.includes(SignupUseCase.AutomatedWorkflows);
}
